import { ColorPickerColors } from '../ColorPicker';

class BlockComponentHeadingColor {
  outerLines: {
    top: string;
    bottom: string;
  };
  innerLines: {
    top: string;
    bottom: string;
  };
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentHeadingColor {
  export function make(): BlockComponentHeadingColor {
    return {
      outerLines: {
        top: ColorPickerColors.BLUE,
        bottom: ColorPickerColors.BLUE,
      },
      innerLines: {
        top: ColorPickerColors.BLUE,
        bottom: ColorPickerColors.BLUE,
      },
    };
  }
}

export default BlockComponentHeadingColor;
